import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { useEventBus } from "@vueuse/core";
import { useAppStore } from "@/ts/stores/app";

interface Props {
    openActive?: boolean;
    dark: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'hamburger-button',
  props: {
    openActive: { type: Boolean, required: false, default: false },
    dark: { type: Boolean, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const appStore = useAppStore();
const bus = useEventBus<string>("hamburger");

const props = __props;

let active = ref(props.openActive);

bus.on((event: string) => {
    switch (event) {
        case "hamburger-close":
            active.value = false;
            break;
        case "hamburger-open":
            active.value = true;
            break;
    }
});

function toggleMenu() {
    if (active.value) {
        bus.emit("hamburger-close");
    } else {
        bus.emit("hamburger-open");
    }

    appStore.navigation.slideout.visible = !appStore.navigation.slideout.visible;
}

const __returned__ = { appStore, bus, props, get active() { return active }, set active(v) { active = v }, toggleMenu }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})